import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60, // 1 minute
      gcTime: 1000 * 60 * 5, // 5 minutes (formerly cacheTime)
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

// Must run synchronously and BEFORE the store state update that remounts the
// routed tree: if clear() lands after the remounted pages create their fresh
// queries, it wipes them and mounted observers hang in isLoading forever
// (TanStack does not refetch an observer whose query is cleared out from
// under it).
export function resetWarehouseScopedCache(): void {
  void queryClient.cancelQueries(); // detach in-flight fetches for the OLD warehouse
  queryClient.clear(); // evict ALL cached queries → true context reset
}
